<template>
  <!--  :style="{backgroundImage:'url('+imgList[0].url+')'}"-->
  <go-back-icon redirect="ConferenceClassList" />
  <div v-if="imgList.length > 0 && imgList[index]" class="bg flex_c" :style="{ backgroundImage: `url('${imgList[index].url}')` }">
    <div class="class--con">
      <class-but i-s-throw-out @forward="forward" @backOfff="backOfff"/>
      <template v-if="imgList[index].isCover">
        <div class="class--rq">&lt;{{ className }}></div>
        <div class="login_qrcode_content">
          <qrcode-vue :value="url" :size="250" level="H"/>
          <div>家长签到</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";
import service from "@/utils/axios";
import GoBackIcon from "@/components/system/GoBackIcon.vue";
import QrcodeVue from 'qrcode.vue'


export default {
  name: "TeacherPPT",
  components: {GoBackIcon, ClassBut, QrcodeVue},
  data() {
    return {
      imgList: [],
      index: 0,
      className: '',
      url: '',
    }
  },
  created() {
    this.className = this.$route.query.name
    this.url = 'http://parent.dawei.art/getSignInCode.html?classId=' + this.$route.query.classId
    this.loadImages()
  },
  methods: {
    async loadImages() {
      let classId = this.$route.query.classId
      let res = await service.post('/dwart/an_teaching/hbk/v1/getReportImages', { classId })
      const images = res || []
      this.imgList = images.map((item, i) => i === 0 ? { ...item, isCover: true } : item)
      const pptIndex = Number(this.$route.query.pptIndex)
      if (!isNaN(pptIndex) && pptIndex >= 0 && pptIndex < this.imgList.length) {
        this.index = pptIndex
      }
    },
    forward() {
      if (this.index < this.imgList.length - 1) {
        this.index++
      } else {
        this.$router.push({
          name: 'PageEighth',
          query: {
            ...this.$route.query,
            fromPPT: '1',
            pptIndex: String(this.index),
          },
        })
      }
    },
    backOfff() {
      if (this.index > 0) {
        this.index--
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import "./reportClass.less";
.flex_c {
  background-size: contain; /* 等比例缩放且不裁剪 */
  background-repeat: no-repeat; /* 防止背景图片重复 */
  background-position: center; /* 背景图片居中显示 */
}

.class--rq {
  width: 281px;
  height: 54px;
  border-radius: 32px;
  box-shadow: 0px 3px 6px rgb(0 0 0 / 20%);
  background-color: #ffffff;
  position: absolute;
  right: 350px;
  bottom: 63px;
  font-size: 36px;
  color: #666666;
  text-align: center;
  line-height: 54px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.login_qrcode_content {
  position: absolute;
  bottom: 10px;
  right: 20px;
  text-align: center;
  color: #2b3654;
  font-size: 24px;
  padding: 10px;
  box-shadow: 0px 3px 6px rgb(0 0 0 / 20%);
  border-radius: 10px;
  background-color: #FFFFFF;
}
</style>
